import Auth, { IAuth } from './Auth';
import Task, { ITask } from './Task';
import Client, { IClient, ClientUrl } from './Client';
import Company, { ICompany } from './Company';
import PhoneNumberType, { IPhoneNumberType } from './PhoneNumberType';
import Project, { IProject, ProjectUrl } from './Project';
import ProjectType, { IProjectType } from './ProjectType';
import Landman, { ILandman } from './Landman';
import User, { IUser } from './User';
import Office, { IOffice } from './Office';
import State, { IState } from './State';
import Tract, { ITract, TractUrl } from './Tract';
import Search, { ISearch } from './Search';
import Owner, { IOwner } from './Owner';
import County, { ICounty } from './County';
import Leasehold, { ILeasehold } from './Leasehold';
import FileManagement, { IFileManagement } from './FileManagement';
import LeaseClauseType from './LeaseClauseType';
import Clauses from './Clauses';
import LeaseGeneration, { ILeaseGeneration } from './LeaseGeneration';
import PerformanceComment, { IPerformanceComment } from './PerformanceComment';
import OwnershipContactCategories, { IOwnershipContactCategories } from './OwnershipContactCategories';
import DocumentTemplates, { IDocumentTemplates } from './DocumentTemplates';
import Tags, { ITags } from './Tags';
import Clone, { IClone } from './Clone';
import Invoice, { IInvoice } from './Invoice';
import Personnel, { IPersonnel } from './Personnel';
import RoleManagement from './RoleManagement';

import Feedback from './Feedback';

class ExportApi {
    private baseUrl = process.env.REACT_APP_BASE_API_URL + '/';

    public Auth: IAuth;
    public Task: ITask;
    public Client: IClient;
    public Company: ICompany;
    public PhoneNumberType: IPhoneNumberType;
    public Project: IProject;
    public ProjectType: IProjectType;
    public Landman: ILandman;
    public User: IUser;
    public Office: IOffice;
    public State: IState;
    public Tract: ITract;
    public Search: ISearch;
    public Owner: IOwner;
    public County: ICounty;
    public Leasehold: ILeasehold;
    public FileManagement: IFileManagement;
    public LeaseClauseType: LeaseClauseType;
    public Clauses: Clauses;
    public LeaseGeneration: ILeaseGeneration;
    public PerformanceComment: IPerformanceComment;
    public Personnel: IPersonnel;
    public RoleManagement: RoleManagement;

    public Feedback: Feedback;
    public OwnershipContactCategories: IOwnershipContactCategories;
    public DocumentTemplates: IDocumentTemplates;
    public Tags: ITags;
    public Clone: IClone;
    public Invoice: IInvoice;

    constructor() {
        this.Auth = new Auth(this.baseUrl);
        this.Task = new Task(this.baseUrl);
        this.Client = new Client(this.baseUrl);
        this.Company = new Company(this.baseUrl);
        this.PhoneNumberType = new PhoneNumberType(this.baseUrl);
        this.Project = new Project(this.baseUrl);
        this.ProjectType = new ProjectType(this.baseUrl);
        this.Landman = new Landman(this.baseUrl);
        this.User = new User(this.baseUrl);
        this.Office = new Office(this.baseUrl);
        this.State = new State(this.baseUrl);
        this.Tract = new Tract(this.baseUrl);
        this.Search = new Search(this.baseUrl);
        this.Owner = new Owner(this.baseUrl);
        this.County = new County(this.baseUrl);
        this.Leasehold = new Leasehold(this.baseUrl);
        this.FileManagement = new FileManagement(this.baseUrl);
        this.LeaseClauseType = new LeaseClauseType(this.baseUrl);
        this.Clauses = new Clauses(this.baseUrl);
        this.LeaseGeneration = new LeaseGeneration(this.baseUrl);
        this.PerformanceComment = new PerformanceComment(this.baseUrl);
        this.Feedback = new Feedback(this.baseUrl);
        this.OwnershipContactCategories = new OwnershipContactCategories(this.baseUrl);
        this.DocumentTemplates = new DocumentTemplates(this.baseUrl);
        this.Tags = new Tags(this.baseUrl);
        this.Clone = new Clone(this.baseUrl);
        this.Invoice = new Invoice(this.baseUrl);
        this.Personnel = new Personnel(this.baseUrl);
        this.RoleManagement = new RoleManagement(this.baseUrl);
    }
}

export default new ExportApi();

export const Url = {
    client: ClientUrl,
    project: ProjectUrl,
    tract: TractUrl,
};



// WEBPACK FOOTER //
// ./src/api/index.ts